import { motion, useReducedMotion } from 'motion/react'

const SIGNATURE_PATH =
  'M2 14 C8 2, 12 2, 14 10 S20 18, 24 8 S32 2, 34 12 S42 16, 46 6'
const SIGN_SECONDS = 1.6
const SIGN_PAUSE_SECONDS = 2.4

// A small drawn check: payee line, amount box and a signature that writes itself.
export const CheckSlip = () => {
  const reduceMotion = useReducedMotion() ?? false
  return (
    <div className="flex h-[72px] w-36 flex-col justify-between rounded-md border bg-white p-2 shadow-sm">
      <div className="flex items-center justify-between">
        <span className="h-1 w-12 rounded-full bg-blue-3" />
        <span className="text-[8px] text-blue-5">No. 1042</span>
      </div>
      <div className="flex items-end gap-1.5">
        <span className="text-[6px] uppercase leading-none text-blue-5">
          Pay to
        </span>
        <span className="h-px flex-1 bg-blue-3" />
        <span className="rounded-sm border px-1 text-[8px] font-semibold text-blue-7">
          $1,250.00
        </span>
      </div>
      <div className="flex items-end justify-between">
        <span className="h-px w-12 bg-blue-3" />
        <svg aria-hidden viewBox="0 0 48 20" className="h-4 w-12 text-blue-6">
          <motion.path
            d={SIGNATURE_PATH}
            fill="none"
            stroke="currentColor"
            strokeWidth={1.4}
            strokeLinecap="round"
            initial={{ pathLength: reduceMotion ? 1 : 0 }}
            animate={{ pathLength: 1 }}
            transition={{
              duration: reduceMotion ? 0 : SIGN_SECONDS,
              ease: 'easeInOut',
              repeat: reduceMotion ? 0 : Number.POSITIVE_INFINITY,
              repeatDelay: SIGN_PAUSE_SECONDS,
            }}
          />
        </svg>
      </div>
    </div>
  )
}
